const STORAGE_KEY = 'themeLastCollectionHandle';
const PRODUCT_CONTEXT_KEY = 'themeLastProductContext';
const SLOT_RECENT_COLLECTION = 'breadcrumb-recent-collection-slot';
const LINK_RECENT_COLLECTION = 'breadcrumb-recent-collection-link';
const SLOT_RECENT_PRODUCT = 'breadcrumb-recent-product-slot';
const LINK_RECENT_PRODUCT = 'breadcrumb-recent-product-link';

const MIN_BREADCRUMB_ITEMS_FOR_SCHEMA_PATCH = 2;

const getProductCollections = () => {
  const contextEl = document.getElementById('breadcrumb-product-context-json');
  const legacyEl = document.getElementById('breadcrumb-product-collections-json');

  if (contextEl) {
    try {
      const context = JSON.parse(contextEl.textContent.trim());
      return Array.isArray(context?.collections) ? context.collections : [];
    } catch (error) {
      console.error('Failed to parse breadcrumb product context JSON:', error);
      return [];
    }
  }

  if (!legacyEl) return [];

  try {
    const candidates = JSON.parse(legacyEl.textContent.trim());
    return Array.isArray(candidates) ? candidates : [];
  } catch (error) {
    console.error('Failed to parse legacy breadcrumb product collections JSON:', error);
    return [];
  }
};

const patchBreadcrumbSchema = (itemsToInsert) => {
  const ldEl = document.getElementById('breadcrumb-ld-json');
  if (!ldEl || !itemsToInsert.length) return;

  try {
    const data = JSON.parse(ldEl.textContent);
    const items = data?.itemListElement;
    if (!Array.isArray(items) || items.length < MIN_BREADCRUMB_ITEMS_FOR_SCHEMA_PATCH) return;

    const origin = window.location.origin;
    const schemaItems = itemsToInsert.map(item => ({
      '@type': 'ListItem',
      position: 0,
      name: item.title,
      item: `${origin}${item.url}`,
    }));

    items.splice(items.length - 1, 0, ...schemaItems);
    items.forEach((el, i) => {
      el.position = i + 1;
    });
    ldEl.textContent = JSON.stringify(data);
  } catch (error) {
    console.error('Failed to patch breadcrumb schema JSON-LD:', error);
  }
};

const revealBreadcrumbSlot = (slotId, linkId, { title, url }) => {
  const slot = document.getElementById(slotId);
  if (!slot || !title || !url) return false;

  const link = slot.querySelector(`#${linkId}`) || slot.querySelector('a');
  if (!link) return false;

  link.href = url;
  link.textContent = title;
  slot.classList.remove('hidden');
  slot.removeAttribute('hidden');
  return true;
};

export function recordLastCollectionFromUrl() {
  try {
    const pathname = window.location.pathname;
    const idx = pathname.indexOf('/collections/');
    if (idx === -1) return;
    const after = pathname.slice(idx + '/collections/'.length);
    const handle = after.split('/')[0];
    if (!handle || handle === 'all') return;
    sessionStorage.setItem(STORAGE_KEY, handle);
  } catch (error) {
    console.error('Failed to record last collection handle in sessionStorage:', error);
  }
}

export function recordLastProductContext() {
  if (!document.body.classList.contains('template-product')) return;

  const dataEl = document.getElementById('breadcrumb-product-context-json');
  if (!dataEl) return;

  try {
    const context = JSON.parse(dataEl.textContent.trim());
    if (!context?.title || !context?.url) return;
    sessionStorage.setItem(PRODUCT_CONTEXT_KEY, JSON.stringify(context));
  } catch (error) {
    console.error('Failed to record last product context in sessionStorage:', error);
  }
}

export function applyRecentCollectionBreadcrumb() {
  if (!document.body.classList.contains('template-product')) return;

  const slot = document.getElementById(SLOT_RECENT_COLLECTION);
  if (!slot) return;

  const candidates = getProductCollections();
  if (!candidates.length) return;

  let handle;
  try {
    handle = sessionStorage.getItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to read last collection handle from sessionStorage:', error);
    return;
  }
  if (!handle) return;

  const match = candidates.find(c => c && c.handle === handle);
  if (!match?.url || !match?.title) return;

  if (!revealBreadcrumbSlot(SLOT_RECENT_COLLECTION, LINK_RECENT_COLLECTION, match)) {
    return;
  }

  patchBreadcrumbSchema([match]);
}

export function applyCartBreadcrumbs() {
  if (!document.body.classList.contains('template-cart')) return;

  let context;
  try {
    const raw = sessionStorage.getItem(PRODUCT_CONTEXT_KEY);
    if (!raw) return;
    context = JSON.parse(raw);
  } catch (error) {
    console.error('Failed to read last product context from sessionStorage:', error);
    return;
  }

  if (!context?.title || !context?.url) return;

  const schemaItems = [];

  let collectionHandle;
  try {
    collectionHandle = sessionStorage.getItem(STORAGE_KEY);
  } catch (error) {
    console.error('Failed to read last collection handle for cart breadcrumbs:', error);
  }

  if (collectionHandle && Array.isArray(context.collections)) {
    const collection = context.collections.find(c => c && c.handle === collectionHandle);
    if (collection?.url && collection?.title) {
      revealBreadcrumbSlot(SLOT_RECENT_COLLECTION, LINK_RECENT_COLLECTION, collection);
      schemaItems.push(collection);
    }
  }

  revealBreadcrumbSlot(SLOT_RECENT_PRODUCT, LINK_RECENT_PRODUCT, context);
  schemaItems.push({ title: context.title, url: context.url });

  patchBreadcrumbSchema(schemaItems);
}
